module.exports = __webpack_public_path__ + "static/img/back-8-2.d96acf74.png";